(function () {
    var cards = document.querySelectorAll("[data-card]");

    //loops through all buttons and adds listener for click
    Array.from(cards).forEach((card) => addEL(card));

    function addEL(card) {
        var link = card.querySelector("a");
        if (link) {
            card.classList.add("-clickable");

            link.addEventListener("focus", function () {
                card.classList.add("card-focus");
            });
            link.addEventListener("blur", function () {
                card.classList.remove("card-focus");
            });
        }

        card.addEventListener("click", function () {
            if (link) {
                var url = link.getAttribute("href");
                var target = link.getAttribute("target") || '_self';
                window.open(url, target);
                link.preventDefault;
            }

        });
    }
})();